(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.score = 0;
        this.status = "idle";
        this.board = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var oldBoard = JSON.stringify(this.board);
                for(var r = 0; r < 4; r++){
                    var row = this.board[r];
                    row = this.slide(row);
                    this.board[r] = row;
                }
                this.afterMove(oldBoard);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var oldBoard = JSON.stringify(this.board);
                for(var r = 0; r < 4; r++){
                    var row = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.board[r]).reverse();
                    row = this.slide(row);
                    this.board[r] = row.reverse();
                }
                this.afterMove(oldBoard);
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var oldBoard = JSON.stringify(this.board);
                for(var c = 0; c < 4; c++){
                    var column = [
                        this.board[0][c],
                        this.board[1][c],
                        this.board[2][c],
                        this.board[3][c]
                    ];
                    column = this.slide(column);
                    for(var r = 0; r < 4; r++)this.board[r][c] = column[r];
                }
                this.afterMove(oldBoard);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var oldBoard = JSON.stringify(this.board);
                for(var c = 0; c < 4; c++){
                    var column = [
                        this.board[0][c],
                        this.board[1][c],
                        this.board[2][c],
                        this.board[3][c]
                    ];
                    column.reverse();
                    column = this.slide(column);
                    column.reverse();
                    for(var r = 0; r < 4; r++)this.board[r][c] = column[r];
                }
                this.afterMove(oldBoard);
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.score = 0;
                this.status = "idle";
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.start();
            }
        },
        {
            // Add your own methods here
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var r = 0; r < 4; r++){
                    for(var c = 0; c < 4; c++)if (this.board[r][c] === 0) emptyCells.push({
                        r: r,
                        c: c
                    });
                }
                if (emptyCells.length === 0) return;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var _emptyCells_randomIndex = emptyCells[randomIndex], row = _emptyCells_randomIndex.r, col = _emptyCells_randomIndex.c;
                this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "slide",
            value: function slide(row) {
                var filtered = row.filter(function(num) {
                    return num !== 0;
                });
                for(var i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1]) {
                    filtered[i] *= 2;
                    this.score += filtered[i];
                    filtered.splice(i + 1, 1);
                }
                while(filtered.length < 4)filtered.push(0);
                return filtered;
            }
        },
        {
            key: "checkStatus",
            value: function checkStatus() {
                if (this.board.flat().includes(2048)) {
                    this.status = "win";
                    return;
                }
                if (this.board.flat().includes(0)) return;
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    var current = this.board[r][c];
                    if (c < 3 && current === this.board[r][c + 1]) return;
                    if (r < 3 && current === this.board[r + 1][c]) return;
                }
                this.status = "lose";
            }
        },
        {
            key: "afterMove",
            value: function afterMove(oldBoard) {
                if (oldBoard !== JSON.stringify(this.board)) {
                    this.addRandomTile();
                    this.checkStatus();
                }
            }
        }
    ]);
    return Game;
}();
var // module.exports = Game;
$3d28d7f1aac198f5$export$2e2bcd8739ae039 = $3d28d7f1aac198f5$var$Game;


"use strict";
// Uncomment the next lines to use your game instance in the browser
// const Game = require('../modules/Game.class');
// const game = new Game();
// Write your code here
var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$startButton = document.querySelector(".start");
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$game.start();
    else if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        var confirmRestart = confirm("You already have a match in progress. Do you really want to restart?");
        if (confirmRestart) $197cd56b15c33885$var$restartGame();
    } else $197cd56b15c33885$var$restartGame();
    $197cd56b15c33885$var$startButton.classList.remove("highlight-restart");
    $197cd56b15c33885$var$renderBoard();
});
// Listener teclado
window.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$renderBoard();
});
function $197cd56b15c33885$var$renderBoard() {
    var board = $197cd56b15c33885$var$game.getState();
    var flatBoard = board.flat();
    var cells = document.querySelectorAll(".field-cell");
    var scoreElement = document.querySelector(".game-score");
    var startMsg = document.querySelector(".message-start");
    var winMsg = document.querySelector(".message-win");
    var loseMsg = document.querySelector(".message-lose");
    if ($197cd56b15c33885$var$game.getStatus() !== "idle") {
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.add("restart");
    }
    if (scoreElement) scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        if (startMsg) startMsg.classList.add("hidden");
        winMsg.classList.add("hidden");
        loseMsg.classList.add("hidden");
    } else if ($197cd56b15c33885$var$game.getStatus() === "win") winMsg.classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        loseMsg.classList.remove("hidden");
        $197cd56b15c33885$var$startButton.classList.add("highlight-restart");
    }
    cells.forEach(function(cell, index) {
        var value = flatBoard[index];
        var previousValue = cell.textContent;
        cell.textContent = value > 0 ? value : "";
        cell.classList.forEach(function(className) {
            if (className.startsWith("field-cell--")) cell.classList.remove(className);
        });
        if (value > 0) {
            cell.classList.add("field-cell--".concat(value));
            if (!previousValue && value > 0) cell.classList.add("tile-new");
            else cell.classList.remove("tile-new");
            if (previousValue && String(previousValue) !== String(value)) cell.classList.add("tile-merged");
            else cell.classList.remove("tile-merged");
        } else cell.classList.remove("tile-new", "tile-merged");
    });
}
function $197cd56b15c33885$var$restartGame() {
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$startButton.textContent = "Restart";
    $197cd56b15c33885$var$startButton.classList.remove("highlight-restart");
    $197cd56b15c33885$var$renderBoard();
}

})();
//# sourceMappingURL=index.4097b5bf.js.map
